export var SENTRY_RELEASE = "016addce62778ffe52286acb912c39f0516b9dda";
